import { render, staticRenderFns } from "./RightCard.vue?vue&type=template&id=bb452874&"
import script from "./RightCard.vue?vue&type=script&lang=ts&"
export * from "./RightCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports